function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QDialog from '../dialog/QDialog.js';
import QIcon from '../icon/QIcon.js';
import QSeparator from '../separator/QSeparator.js';
import QCard from '../card/QCard.js';
import QCardSection from '../card/QCardSection.js';
import QItem from '../item/QItem.js';
import QItemSection from '../item/QItemSection.js';
import DarkMixin from '../../mixins/dark.js';
import AttrsMixin from '../../mixins/attrs.js';
import cache from '../../utils/cache.js';
export default Vue.extend({
  name: 'BottomSheetPlugin',
  mixins: [DarkMixin, AttrsMixin],
  inheritAttrs: false,
  props: {
    title: String,
    message: String,
    actions: Array,
    grid: Boolean,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  computed: {
    dialogProps: function dialogProps() {
      return _objectSpread(_objectSpread({}, this.qAttrs), {}, {
        position: 'bottom'
      });
    }
  },
  methods: {
    show: function show() {
      this.$refs.dialog.show();
    },
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onOk: function onOk(action) {
      this.$emit('ok', action);
      this.hide();
    },
    __getGrid: function __getGrid(h) {
      var _this = this;

      return this.actions.map(function (action) {
        var img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator, {
          staticClass: 'col-all',
          props: {
            dark: _this.isDark
          }
        }) : h('div', {
          staticClass: 'q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position',
          "class": action.classes,
          attrs: {
            tabindex: 0
          },
          on: {
            click: function click() {
              return _this.onOk(action);
            },
            keyup: function keyup(e) {
              e.keyCode === 13 && _this.onOk(action);
            }
          }
        }, [h('div', {
          staticClass: 'q-focus-helper'
        }), action.icon ? h(QIcon, {
          props: {
            name: action.icon,
            color: action.color
          }
        }) : img ? h('img', {
          attrs: {
            src: img
          },
          staticClass: action.avatar ? 'q-bottom-sheet__avatar' : null
        }) : h('div', {
          staticClass: 'q-bottom-sheet__empty-icon'
        }), h('div', [action.label])]);
      });
    },
    __getList: function __getList(h) {
      var _this2 = this;

      return this.actions.map(function (action) {
        var img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator, {
          props: {
            spaced: true,
            dark: _this2.isDark
          }
        }) : h(QItem, {
          staticClass: 'q-bottom-sheet__item',
          "class": action.classes,
          props: {
            tabindex: 0,
            clickable: true,
            dark: _this2.isDark
          },
          on: {
            click: function click() {
              return _this2.onOk(action);
            },
            keyup: function keyup(e) {
              e.keyCode === 13 && _this2.onOk(action);
            }
          }
        }, [h(QItemSection, {
          props: {
            avatar: true
          }
        }, [action.icon ? h(QIcon, {
          props: {
            name: action.icon,
            color: action.color
          }
        }) : img ? h('img', {
          attrs: {
            src: img
          },
          staticClass: action.avatar ? 'q-bottom-sheet__avatar' : null
        }) : null]), h(QItemSection, [action.label])]);
      });
    }
  },
  render: function render(h) {
    var _this3 = this;

    var child = [];
    this.title && child.push(h(QCardSection, {
      staticClass: 'q-dialog__title'
    }, [this.title]));
    this.message && child.push(h(QCardSection, {
      staticClass: 'q-dialog__message'
    }, [this.message]));
    child.push(this.grid === true ? h('div', {
      staticClass: 'row items-stretch justify-start'
    }, this.__getGrid(h)) : h('div', this.__getList(h)));
    return h(QDialog, {
      ref: 'dialog',
      props: this.dialogProps,
      on: cache(this, 'hide', {
        hide: function hide() {
          _this3.$emit('hide');
        }
      })
    }, [h(QCard, {
      staticClass: "q-bottom-sheet q-bottom-sheet--".concat(this.grid === true ? 'grid' : 'list') + (this.isDark === true ? ' q-bottom-sheet--dark q-dark' : ''),
      style: this.cardStyle,
      "class": this.cardClass
    }, child)]);
  }
});